@if (activity()) {
	<div class="game-container">
		@for (contentInActivity of activity()!.content; track contentInActivity; let i = $index; let last = $last) {
			<div
				[ngClass]="[contentInActivity.content_type.replace(':', '-')]"
				[class.player-non-scrollable]="contentInActivity.featured_mode === true"
				[class.player-scrollable]="contentInActivity.featured_mode === false"
			>
				@if (contentInActivity.content_type == ContentType.H5P) {
					<app-h5p-player
						[activity]="activity()"
						[content]="contentInActivity"
						(onReady)="onH5pReady(i, $event)"
						[dontTrackTake]="dontTrackTake()"
					></app-h5p-player>
				}
				@if (contentInActivity.content_type == ContentType.COACH) {
					<app-hubs-player
						[activity]="activity()"
						[content]="contentInActivity"
						[dontTrackTake]="dontTrackTake()"
					></app-hubs-player>
				}
				@if (
					contentInActivity.content_type == ContentType.DISPLAY &&
					contentInActivity.active_text?.description_html
				) {
					<app-rich-text-player
						[content]="contentInActivity"
						[dontTrackTake]="dontTrackTake()"
					></app-rich-text-player>
				}
			</div>
		}
	</div>
}
